<div id="{{containerId}}"></div>
<app-tabs *ngIf="data?.brands?.length && !loading"
    (emitter)="switchTab($event)"
    [tabs]="['Device', 'Brand']"
    [initialTab]="selectedType"
    [styleClass]="'performance-map'">
</app-tabs>
<app-no-widget-data
    *ngIf="!data?.brands?.length && !loading"
    [svgSrc]="data?.isInDeviceBreakdown
      ? 'svg/no-widget-data-device-break-down.svg'
      : 'svg/no-widget-data.svg'">
</app-no-widget-data>
<app-loader *ngIf="loading"></app-loader>